import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { RouterModule } from '@angular/router';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { AppMenuComponentModule } from './components/app-menu/app-menu.module';
import { SharedFunctionService } from '../services/common/shared-function.service';
import { HandleErrorService } from '../services/common/handle-error.service';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { MinutesToTimePipe } from './pipes/minutes-to-time.pipe';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PhoneNumberComponent } from './components/phone-number/phone-number.component';
import { GetDirectionsComponent } from './components/get-directions/get-directions.component';
import { DealerDetailsComponent } from './components/dealer-details/dealer-details.component';
import { SharedDataService } from '../services/common/shared-data.service';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { ImageErrorDirective } from "./directives/image-error.directive";
import { ThreeSixtyPhotoViewerComponent } from './components/three-sixty-photo-viewer/three-sixty-photo-viewer.component';
import { LoaderComponent } from './components/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { CommentsDialogComponent } from './components/vehicle-detail-header/comments-dialog/comments-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    AppMenuComponentModule,
    FormsModule
  ],
  exports: [
    MaterialModule,
    AppHeaderComponent,
    AppFooterComponent,
    PhoneNumberPipe,
    RouterModule,
    MinutesToTimePipe,
    PageNotFoundComponent,
    PhoneNumberComponent,
    GetDirectionsComponent,
    DealerDetailsComponent,
    PageTitleComponent,
    ImageErrorDirective,
    ThreeSixtyPhotoViewerComponent,
    LoaderComponent,
    FormsModule,
    CommentsDialogComponent
  ],
  declarations: [
    AppHeaderComponent,
    AppFooterComponent,
    PhoneNumberPipe,
    MinutesToTimePipe,
    PageNotFoundComponent,
    PhoneNumberComponent,
    GetDirectionsComponent,
    DealerDetailsComponent,
    PageTitleComponent,
    ImageErrorDirective,
    ThreeSixtyPhotoViewerComponent,
    LoaderComponent,
    CommentsDialogComponent
  ],
  providers: [
    HandleErrorService,
    SharedFunctionService
  ]
})
// Shared module
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        SharedDataService
      ]
    };
  }

}
